(() => {
  if (customElements.get('wd-project-image')) return;
  class ProjectImage extends HTMLElement {
    connectedCallback() {
      const image = this.querySelector('img[data-src]');
      if (!image) return;
      const reveal = () => {
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        image.src = image.dataset.src;
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-src');
        this.observer?.disconnect();
      };
      if (!('IntersectionObserver' in window)) { reveal(); return; }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) reveal();
      }, {rootMargin: '200px'});
      this.observer.observe(this.parentElement);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  customElements.define('wd-project-image', ProjectImage);
})();
